/* unplugin-vue-components disabled */import { unref as _unref, renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export default {
  __name: 'EditorButton',
  props: {
    join: {
      type: Boolean,
      default: false
    }
  },
  setup(__props) {
    // btn background color #0d0e13
    const props = __props;
    const isHovered = ref(false);
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("button", {
        onMouseenter: _cache[0] || (_cache[0] = $event => isHovered.value = true),
        onMouseleave: _cache[1] || (_cache[1] = $event => isHovered.value = false),
        class: _normalizeClass(["editor-button btn btn-square bg-primaryDark", {
          'join-item': __props.join
        }])
      }, [_createElementVNode("div", {
        class: _normalizeClass(["opacity-50", {
          '!opacity-100': _unref(isHovered)
        }])
      }, [_renderSlot(_ctx.$slots, "default")], 2)], 34);
    };
  }
};